import { useState, useEffect } from 'react';

const TUTORIAL_STORAGE_KEY = 'junkfun_tutorial_completed';

export function useTutorial() {
  const [showTutorial, setShowTutorial] = useState(false);
  const [hasCompletedTutorial, setHasCompletedTutorial] = useState(false);

  // Check if user has completed tutorial on mount
  useEffect(() => {
    const completed = localStorage.getItem(TUTORIAL_STORAGE_KEY);
    setHasCompletedTutorial(completed === 'true');

    // Auto-show tutorial for first-time visitors
    if (!completed) {
      // Small delay to let the page load first
      const timer = setTimeout(() => {
        setShowTutorial(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const completeTutorial = () => {
    localStorage.setItem(TUTORIAL_STORAGE_KEY, 'true');
    setHasCompletedTutorial(true);
    setShowTutorial(false);
  };

  const openTutorial = () => {
    console.log('[useTutorial] openTutorial called, setting showTutorial to true');
    setShowTutorial(true);
  };

  const closeTutorial = () => {
    setShowTutorial(false);
  };

  const resetTutorial = () => {
    localStorage.removeItem(TUTORIAL_STORAGE_KEY);
    setHasCompletedTutorial(false);
  };

  return {
    showTutorial,
    hasCompletedTutorial,
    openTutorial,
    closeTutorial,
    completeTutorial,
    resetTutorial,
  };
}
